export const SET_NOTIFICATION = 'mainLayout/SET_NOTIFICATION';
export const DELETE_NOTIFCATION = 'mainLayout/DELETE_NOTIFCATION';
export const HANDLE_CATCH_ERROR = 'HANDLE_CATCH_ERROR';
